import { useSelector } from 'react-redux';

export const generateNavigationPaths = (candidateId) => {
  candidateId = _.isObject(candidateId) ? 'New Candidate' : candidateId;
  return ({
    '/users': [{ label: 'Users', class: 'bcActiveMenu' }],
    '/candidates': [{ label: 'Candidates', class: 'bcActiveMenu' }],
    '/candidate/candidate-personal-info': [
      { label: 'Candidates', class: 'bcMainMenu' },
      { label: '/', class: 'bcSeperation' },
      { label: candidateId, class: 'bcMainMenu' },
      { label: '/', class: 'bcSeperation' },
      { label: 'Personal Details', class: 'bcActiveMenu' },
    ],
    '/candidate/candidate-work-experience': [
      { label: 'Candidates', class: 'bcMainMenu' },
      { label: '/', class: 'bcSeperation' },
      { label: candidateId, class: 'bcMainMenu' },
      { label: '/', class: 'bcSeperation' },
      { label: 'Work Experience', class: 'bcActiveMenu' },
    ],
    '/candidate/candidate-education-details': [
      { label: 'Candidates', class: 'bcMainMenu' },
      { label: '/', class: 'bcSeperation' },
      { label: candidateId, class: 'bcMainMenu' },
      { label: '/', class: 'bcSeperation' },
      { label: 'Education Details', class: 'bcActiveMenu' },
    ],
    '/candidate/candidate-compensation-details': [
      { label: 'Candidates', class: 'bcMainMenu' },
      { label: '/', class: 'bcSeperation' },
      { label: candidateId, class: 'bcMainMenu' },
      { label: '/', class: 'bcSeperation' },
      { label: 'Compensation Details', class: 'bcActiveMenu' },
    ],
    '/candidate/candidate-value-adds': [
      { label: 'Candidates', class: 'bcMainMenu' },
      { label: '/', class: 'bcSeperation' },
      { label: candidateId, class: 'bcMainMenu' },
      { label: '/', class: 'bcSeperation' },
      { label: 'Value Adds', class: 'bcActiveMenu' },
    ],
    '/candidate/candidate-curated-clients': [
      { label: 'Candidates', class: 'bcMainMenu' },
      { label: '/', class: 'bcSeperation' },
      { label: candidateId, class: 'bcMainMenu' },
      { label: '/', class: 'bcSeperation' },
      { label: 'Curated Clients', class: 'bcActiveMenu' },
    ],
    '/candidate-assignment': [{ label: 'Candidate Assignments', class: 'bcActiveMenu' }],
    '/add-client': [{ label: 'Add Client', class: 'bcActiveMenu' }],
    '/update-client': [{ label: 'Update Client', class: 'bcActiveMenu' }],
    '/clients': [{ label: 'Clients', class: 'bcActiveMenu' }],
    '/unapproved-candidates': [
      { label: 'Unapproved Candidates', class: 'bcActiveMenu' }
    ],
  })
};
